import { globalsSelector } from 'utils/selectors/globalsSelectors';
import currentLanguageSelector from 'utils/selectors/languageSelectors';
import { currentPageSelector, currentPageTypeSelector } from 'utils/selectors/pageSelectors';
import { footerPreviewIdSelector } from 'utils/selectors/footerNavigationSelectors';
import { navigationMetaPreviewIdSelector } from 'utils/selectors/navigationSelectors';
import {
  addSectionToPage,
  doUpdateSectionOnPage,
  updateImage,
  updatePage,
  updateSectionOnPage,
} from '../Page/actions';
import { updateTranslation } from '../Translation/actions';
import { deleteChannel, updateChannel } from '../VideoGallery/actions';
import {
  TPP_TYPE_DOWNLOAD,
  TPP_TYPE_IMAGE,
  TPP_TYPE_NEWSECTION,
  TPP_TYPE_PAGE,
  TPP_TYPE_SHORTURL,
  TPP_TYPE_TRANSLATION_STATICPAGE,
  TPP_TYPE_VIDEOCHANNEL,
} from './tppConstants';
import { Log } from 'services/log';

export function parseContentOnChange(state, dispatch, content, previewId) {
  const replacementTags = globalsSelector(state)?.replacementTags;
  if (content === null) {
    const currentPageType = currentPageTypeSelector(state);

    if (currentPageType?.includes('videocenter')) {
      dispatch(deleteChannel({ previewId }));
    }

    document.querySelector(`[data-preview-id="${previewId}"]`)?.removeAttribute('data-preview-id');
  } else if (content && replacementTags) {
    try {
      let contentStr = JSON.stringify(content);
      Object.keys(replacementTags).forEach((key) => {
        const value = replacementTags[key];
        contentStr = contentStr.replaceAll(key, value);
      });
      content = JSON.parse(contentStr);
    } catch (e) {
      Log.error('Error while parsing content', e);
    }
  }

  return content;
}

export function checkDispatchShortUrls(pathname, content, $node, previewId) {
  if (pathname === '/_shorturls') {
    window.dispatchEvent(
      new CustomEvent('fscc.update.shorturls', {
        detail: {
          type: !content ? 'delete' : 'update',
          sender: {
            $node,
            previewId,
          },
          content,
        },
      }),
    );
  }
}

export function checkDispatchDownloads(pathname, content, $node, previewId) {
  if (pathname === '/_downloads') {
    window.dispatchEvent(
      new CustomEvent('fscc.update.downloads', {
        detail: {
          type: !content ? 'delete' : 'update',
          sender: {
            $node,
            previewId,
          },
          content,
        },
      }),
    );
  }
}

export function checkDispatchTranslations(pathname, content, state, dispatch) {
  if (pathname === '/_translations') {
    const currentLanguage = currentLanguageSelector(state);
    if (currentLanguage) {
      dispatch(updateTranslation(content, currentLanguage));
    }
  }
}

export function handleUpdateByType(
  dispatch,
  dispatchPageAction,
  $node,
  previewId,
  content,
  state: AppState,
) {
  switch ($node.dataset.editType) {
    case TPP_TYPE_IMAGE: {
      const pageContent = currentPageSelector(state);
      dispatchPageAction(
        updateImage(
          {
            previewId,
            reference: content,
          },
          pageContent,
        ),
      );
      break;
    }
    case TPP_TYPE_PAGE:
      // if type is a page type then page has changed, else a child was added
      if (content.page) {
        dispatchPageAction(
          updatePage({
            previewId,
            content,
          }),
        );
      } else {
        const footerId = footerPreviewIdSelector(state);
        const metaId = navigationMetaPreviewIdSelector(state);
        if (previewId === footerId && previewId === metaId) {
          dispatch(
            updateSectionOnPage({
              previewId,
              content,
            }),
          );
        } else {
          dispatchPageAction(doUpdateSectionOnPage({ content, previewId }));
        }
      }
      break;
    case TPP_TYPE_NEWSECTION:
      dispatchPageAction(
        addSectionToPage({
          context: {
            body: $node.dataset.editArea,
            position: 0,
          },
          content,
        }),
      );
      break;
    case TPP_TYPE_VIDEOCHANNEL:
      dispatch(updateChannel(content));
      break;
    default:
      // start workaround for architectural tpp problem: content.isInSubscription is null
      if ($node.dataset.isInSubscription === 'true') {
        content.isInSubscription = true;
      }
      // end workaround

      if (
        $node.dataset.editType !== TPP_TYPE_TRANSLATION_STATICPAGE ||
        $node.dataset.editType !== TPP_TYPE_SHORTURL ||
        $node.dataset.editType !== TPP_TYPE_DOWNLOAD
      ) {
        const footerId = footerPreviewIdSelector(state);
        const metaId = navigationMetaPreviewIdSelector(state);
        if (previewId === footerId && previewId === metaId) {
          dispatch(
            updateSectionOnPage({
              previewId,
              content,
            }),
          );
        } else {
          dispatchPageAction(doUpdateSectionOnPage({ content, previewId }));
        }
      }
  }
}
